import { render, staticRenderFns } from "./EstadoEconomico.vue?vue&type=template&id=2469b55a&"
import script from "./EstadoEconomico.vue?vue&type=script&lang=js&"
export * from "./EstadoEconomico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports